import { Container } from "../Container/Container";

export class SelectorHead extends Container {
    protected initialize(data: any) {
        super.initialize(data);
        this.addClass("dsh");
    }
}
